import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialSection } from './components/TestimonialSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PurchaseSection } from './components/PurchaseSection';
import { NotificationPopup } from './components/NotificationPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <BonusSection data-id="element-5" />
        <PurchaseSection data-id="element-6" />
        <TestimonialSection data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
      </main>
      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm border-t border-gray-800" data-id="element-9">
        <div className="container mx-auto px-4" data-id="element-10">
          <p className="mb-4 font-medium" data-id="element-11">
            © {new Date().getFullYear()} PACK INGLÉS LISTO™. Todos los
            derechos reservados.
          </p>
          <p className="max-w-2xl mx-auto text-gray-500 text-xs leading-relaxed" data-id="element-12">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
        <NotificationPopup data-id="element-13" />
      </footer>
      <MetaPixel data-id="element-14" />
    </div>;
}